import React, { Component } from 'react';

export class RegionInsightButton extends Component {
    render() {
        return (
            <div onClick={(e) => this.props.onClick(this.props.tag)} className={"regioninsightbtn" + (this.props.isChecked ? " checked" : "")}><img className="icon" alt="button" src={this.props.icon} /><h5>{this.props.title}</h5>{this.props.isChecked ? <img alt="divit" className="check" src="/images/controls/insightarrow.svg" /> : ""}</div>
        );
    }
}
